export enum OperationType {
  MOVE,
  COPY
}
